import { createAction, props } from '@ngrx/store';

export const loadAirlines = createAction('[Airlines] Load Airlines');

export const loadAirlinesSuccess = createAction(
  '[Airlines] Load Airlines Success',
  props<{ airlines: any[] }>()
);

export const loadAirlinesFailure = createAction(
  '[Airlines] Load Airlines Failure',
  props<{ error: string }>()
);
